import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card h-100 border-0 rounded-0 bg-white stats-box" }
const _hoisted_2 = { class: "card-body d-flex pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative rounded-circle text-center flex-shrink-0 text-danger" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-user-plus" })
], -1 /* HOISTED */)
const _hoisted_5 = { class: "title ms-15" }
const _hoisted_6 = { class: "fw-black lh-1 m-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-plus position-relative ms-5 fs-12" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h4", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/invite-user",
              class: "text-decoration-none text-fk-primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('cta.invite_user')) + " ", 1 /* TEXT */),
                _hoisted_7
              ]),
              _: 1 /* STABLE */
            })
          ])
        ])
      ])
    ])
  ]))
}